export enum SalesVolumeOptionEnum {
    BILLS_VOLUME = 'BILLS_VOLUME',
    SALES_PLANNING = 'SALES_PLANNING',
}
